import { render, staticRenderFns } from "./profile-social.vue?vue&type=template&id=1a33dcfd"
import script from "./profile-social.vue?vue&type=script&lang=js"
export * from "./profile-social.vue?vue&type=script&lang=js"
import style0 from "./profile-social.vue?vue&type=style&index=0&id=1a33dcfd&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports